import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
imageLoadError: boolean = false;
imagePreview: string | ArrayBuffer | null = null;
selectedImageFile: File | null = null;
readonly defaultProfileImage = 'assets/images/icons/logo.jpg';

  public userArticles: any[] = [];

  /**
   *
   * Variable 
   *
   */
  public userData : any
  public isEditMode : boolean = false
  

  constructor(
    private apiService : ApisService, 
    private loading : LoadingService, 
    private activatedRoute : ActivatedRoute , 
    private toastr: ToastrService

  ) { }

  ngOnInit(): void {
    // this.activatedRoute.params.subscribe((res) => {
    //   const id  = res['id']
    //   this.userDetails(id)
    // })

     this.activatedRoute.params.subscribe((res) => {
    const id = res['id'];
    this.userDetails(id);
    this.getUserArticles(id); // 👈 fetch articles here
  });
  }

  
  /*----------  Get user Details  ----------*/
    userDetails(id: any) {
      this.loading.show()
    this.apiService.userDetails(id).subscribe({
      next: (res) => {
        this.userData = res.data
        this.imagePreview = null;
        this.imageLoadError = false;
        console.log(this.userData)
        this.loading.hide()
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
        this.loading.hide()
      }
    })
  } 

  
  /*----------  Edit User  ----------*/
  editUser() {
    const data = this.selectedImageFile ? this.createUserFormData() : this.createUserPayload();

    this.apiService.editUser(this.userData.id , data).subscribe({
      next: (res) => {
        if (res?.data) {
          this.userData = res.data;
          this.imagePreview = null;
          this.selectedImageFile = null;
          this.imageLoadError = false;
        }
        this.toastr.success("Updated Successfully", "Success")
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length > 0 ? input.files[0] : null;

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.toastr.warning('Please select a valid image file', 'Invalid file');
      input.value = '';
      return;
    }

    this.selectedImageFile = file;
    this.imageLoadError = false;

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result;
    };
    reader.readAsDataURL(file);
  }

  private createUserFormData(): FormData {
    const formData = new FormData();
    const fields = ['name', 'email', 'mobile', 'country_id', 'city_id', 'bio', 'user_gender'];

    fields.forEach((field) => {
      const value = this.userData?.[field];
      if (value !== undefined && value !== null) {
        formData.append(field, String(value));
      }
    });

    if (this.selectedImageFile) {
      formData.append('image', this.selectedImageFile);
    }

    return formData;
  }

  private createUserPayload(): any {
    const payload: any = {};
    const fields = ['name', 'email', 'mobile', 'country_id', 'city_id', 'bio', 'user_gender'];

    fields.forEach((field) => {
      const value = this.userData?.[field];
      if (value !== undefined && value !== null) {
        payload[field] = value;
      }
    });

    return payload;
  }
  
  /*----------  Handling Image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }

  get profileImageUrl(): string | ArrayBuffer {
    return this.imagePreview || this.normalizeImageUrl(this.userData?.image) || this.defaultProfileImage;
  }

  handleProfileImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    if (!image || image.src.includes(this.defaultProfileImage)) return;
    image.src = this.defaultProfileImage;
  }

  private normalizeImageUrl(image: string | null | undefined): string {
    if (!image || typeof image !== 'string') return '';

    const value = image.trim().replace(/\\\//g, '/').replace(/^"|"$/g, '');
    if (!value) return '';
    if (/^(https?:|data:|blob:|assets\/)/i.test(value)) return value;
    if (value.startsWith('//')) return `https:${value}`;
    if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(value)) return `https://${value}`;

    const apiOrigin = environment.apiUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
    if (value.startsWith('/')) return `${apiOrigin}${value}`;
    if (value.startsWith('storage/') || value.startsWith('AdminPanelAssetFiles/')) return `${apiOrigin}/${value}`;

    return `${apiOrigin}/storage/${value}`;
  }


  getUserArticles(id: any) {
  this.loading.show();
  this.apiService.getUserArticles(id).subscribe({
    next: (res) => {
      this.userArticles = res.data || [];
      console.log('User Articles:', this.userArticles);
      this.loading.hide();
    },
    error: (err) => {
      console.log('error in fetching articles', err);
      this.toastr.error('Failed to load articles', 'Error');
      this.loading.hide();
    }
  });
}

}
